import UserSession from "../../../services/UserSession";
import { SETTINGS_LOADED, settingsLoaded, UPDATE_SETTINGS } from "../actions";


const settings = (
    state = {
        allAudioVolume: 30,
        messageReceivedVolume: 100,
        playerTurnVolume: 100,

        settingsLoaded: false,
    },
    action
) => {
    switch (action.type) {
        case UPDATE_SETTINGS: return saveSettings(state, action.payload.settings);
        case SETTINGS_LOADED: return Object.assign({ settingsLoaded: true, }, state, action.payload.settings);
        default: return state;
    }
};
export default settings;

let lastSettingsState = null;
let saveSettingsTimeout = null;

function saveSettings(state, newValue) {
    if (typeof newValue === "object") {
        state = Object.assign({}, state, newValue);
    }

    lastSettingsState = state;
    if (!saveSettingsTimeout) {
        saveSettingsTimeout = setTimeout(() => {
            saveSettingsTimeout = null;
            const state = lastSettingsState;
            lastSettingsState = null;

            UserSession.setLocalUserSettings(state).catch((err) => {
                console.error("error saving settings", err);
            });
        }, 500);
    }

    return state;
}

export const performLoadSettings = () => async (dispatch) => {
    try {
        const settings = await UserSession.getLocalUserSettings();
        dispatch(settingsLoaded(settings));
    } catch (e) {
        console.error("error loading settings", e);
    }
};